<template>
  <div class="table-action-wrapper">
    <input type="date" class="form-control has-tip" data-title="Start Date" :value="query.date_start.value" @change="changeDateStart" />
    <input type="date" class="form-control has-tip" data-title="End Date" :value="query.date_end.value" @change="changeDateEnd" />
    <Select :options="statusOptions()" placeholder="Account Status" data-title="Account Status" class="has-tip" v-model="query.status"></Select>
    <Select source="user/search" type="auto" field="sale-account.user_read" placeholder="Seller" data-title="Seller" class="has-tip" v-model="query.user_ids"></Select>
    <Select :options="loggedOptions()" placeholder="Account Login Status" data-title="Account Login Status" class="has-tip" v-model="query.logged"></Select>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      query: {
        date_start: moment().format('Y-MM-DD'),
        date_end: moment().format('Y-MM-DD'),
        account_id: '',
        user_ids: '',
        logged: ''
      }
    }
  },
  computed: {
    tableNavOptions() {
      return Object.assign(
        {
          logged: [],
          status: []
        },
        this.config?.extraAttributes || {}
      )
    }
  },
  props: {
    config: Object
  },
  methods: {
    changeDateStart(e) {
      this.query.date_start = Object.assign(this.query.date_start, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$emit('change-filters', this.query)
    },
    changeDateEnd(e) {
      this.query.date_end = Object.assign(this.query.date_end, {
        value: e.currentTarget.value,
        valueLabel: e.currentTarget.value
      })
      this.$emit('change-filters', this.query)
    },
    loggedOptions() {
      return this.tableNavOptions.logged
    },
    statusOptions() {
      return this.tableNavOptions.status
    },
    submit() {
      this.$emit('change-filters', this.query)
    }
  }
}
</script>
